import React, { useEffect, useState } from 'react';
import * as S from './estilos';

// import { Schedule } from '..';
// IconDownload
import BgImprensaResp from '../../Images/BgImprensaResp.jpg';
import IconDownload from '../../Images/IconDownload.png';
import ImgBgImprensa from '../../Images/BgImprensa.jpg';
import useData from '../../Utils/useData';

const PressInside = () => {
  const [data, setData] = useState<any>([]);
  const [data2, setData2] = useState<any>([]);
  const loadData = () => {
    useData()
      .getData('imprensa1.php')
      .then((response: any) => {
        setData(response);
      })
      .catch((err) => {
        console.info(err);
      });

    useData()
      .getData('imprensa2.php')
      .then((response: any) => {
        setData2(response);
      })
      .catch((err) => {
        console.info(err);
      });
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <S.ForaAltura>
      <S.OutBgResp>
        <img src={BgImprensaResp} />
      </S.OutBgResp>

      <S.BgPress>
        <img src={ImgBgImprensa} />
      </S.BgPress>


      <S.Fora>
        <S.TextPress3>Imprensa</S.TextPress3>

        <S.TextProduction2>
          Área destinada a conteúdos de imprensa como release e fotos.
        </S.TextProduction2>

        <S.ItemProduction2 onClick={() => window.open('https://drive.google.com/drive/folders/1AKUQNUh_ADrOVjWgOBw4LVIwM6DXvANL')} >
          <S.TextProduction3>ACESSE</S.TextProduction3>
        </S.ItemProduction2>
         <S.TextProduction2 style={{marginTop:'40px'}}>
         Solicitação de Credenciamento de Eventos
        </S.TextProduction2>

        <S.ItemProduction2 onClick={() => window.open('https://bit.ly/credenciamento-danielpromocoes')}>
          <S.TextProduction3>SOLICITE</S.TextProduction3>
        </S.ItemProduction2>
      </S.Fora>


      {/* <S.OutPress>
          <S.ItemProduction2>
              <S.TextProduction3>Produtor Técnico</S.TextProduction3>
              <S.TextProduction4>Joel Araujo</S.TextProduction4>
              <S.TextProduction5>joel@danielpromocoes.com.br</S.TextProduction5>
            </S.ItemProduction2>
       
        </S.OutPress> */}
    </S.ForaAltura>
  );
};

export default PressInside;
